// Works
export const works_es = [
  {
    title: "Sublima Lashes",
    subtitle: "E-commerce",
    category: "Desarrollo Wordpress",
    tags: ["Wireframes", "Templates", "CSS3", "UI/UX", "WPO", "Landing Page"],
    cover: "./img/projects/sublima--3.webp",
    link: "https://www.sublimalashes.com/",
    class: "full wide",
  },
  {
    title: "Delaviuda",
    subtitle: "E-commerce",
    category: "Desarrollo Wordpress",
    tags: ["Templates", "CSS3", "ACF", "WooCommerce", "SEO", "WPO"],
    cover: "./img/projects/delaviuda.webp",
    link: "https://www.delaviuda.com/",
    class: "square half",
  },
  {
    title: "El Almendro",
    subtitle: "E-commerce",
    category: "Desarrollo Wordpress",
    tags: ["Templates", "CSS3", "ACF", "WooCommerce", "SEO", "WPO"],
    cover: "./img/projects/elalmendro.webp",
    link: "https://www.elalmendro.com/",
    class: "square half",
  },
  {
    title: "PSworks",
    subtitle: "Agencia",
    category: "Desarrollo Wordpress",
    tags: ["JS", "CSS3", "ACF", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/psworks_02.webp",
    link: "https://www.psworks.es/",
    class: "full wide",
  },
  {
    title: "Socialisssima",
    subtitle: "Agencia",
    category: "Diseño & Desarrollo Wordpress",
    tags: ["JS", "CSS3", "ACF", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/socialisssima_2024.webp",
    link: "https://socialisssima.com/",
    class: "full wide",
  },
  {
    title: "Pollinators & Prairies",
    subtitle: "Institución",
    category: "Desarrollo Wordpress",
    tags: ["UX", "UI", "PHP", "CSS3", "SEO", "WPO"],
    cover: "./img/projects/pp_texas.webp",
    link: "https://pollinatorsandprairies.org/",
    class: "square half",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1369&category=trabajo-cotidiano",
  },
  {
    title: "Amazon FE",
    subtitle: "Consultoría",
    category: "Wordpress UX / UI",
    tags: ["UI", "UX", "Análisis Heurístico"],
    cover: "./img/projects/amazon_fe.webp",
    link: "https://www.amazonfutureengineer.com/",
    blog_link: "https://juanfalibene.com/writing/#/project/109",
    class: "square half",
  },
  {
    title: "Irene Pietrella",
    subtitle: "Portfolio",
    category: "Desarrollo Wordpress",
    tags: ["PHP", "JS", "CSS3", "ACF", "Templates", "SEO", "WPO"],
    cover: "./img/projects/irene-pietrella.webp",
    link: "https://irene-pietrella.com/",
    blog_link: "https://juanfalibene.com/writing/#/case-study/84",
    class: "vertical quarter",
  },
  {
    title: "Martina Orska",
    subtitle: "Portfolio",
    category: "Desarrollo Wordpress",
    tags: ["PHP", "ACF", "CPT UI", "JS", "CSS3", "SEO", "WPO"],
    cover: "./img/projects/martina_orska.webp",
    link: "https://martinaorska.com/",
    blog_link: "https://juanfalibene.com/writing/#/case-study/831",
    class: "vertical quarter",
  },
  {
    title: "Rocio Ley",
    subtitle: "Portfolio",
    category: "Desarrollo Wordpress",
    tags: ["ACF", "JS", "CSS3", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/03_smoda.webp",
    link: "https://rocioley.com",
    class: "vertical quarter",
    blog_link: "https://juanfalibene.com/writing/#/case-study/11",
  },
];

// Projects
export const projects_es = [
  {
    title: "Discava!",
    subtitle: "APP Búsqueda Vinilos",
    category: "Desarrollo Front-End",
    tags: [
      "HTML5",
      "CSS3",
      "JS Vanilla",
      "Discogs API",
      "Youtube Playlist",
      "Local Storage",
    ],
    cover: "./img/projects/discava-v2.webp",
    link: "http://dev.juanfalibene.com/discava/index.html",
    github_link: "https://github.com/juanfalibene/discava-digital",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1943&category=idea-de-proyecto",
    class: "full wide",
  },
  {
    title: "CaliTrack",
    subtitle: "App de IA",
    category: "AI vibe coding",
    tags: ["React.js", "CSS3", "JS Vanilla", "HTML5"],
    cover: "./img/projects/calitrack_mobile.webp",
    link: "https://jf-calitrack.lovable.app/",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1909&category=idea-de-proyecto",
    class: "half square",
  },
  {
    title: "Juan Falibene Writing",
    subtitle: "WP Headless",
    category: "Desarrollo Front-End & Wordpress",
    tags: [
      "WP REST API",
      "JWT Auth",
      "ACF",
      "CPT UI",
      "React.js",
      "CSS3",
      "HTML5",
      "SEO",
    ],
    cover: "./img/projects/project_blog_writing.webp",
    link: "https://juanfalibene.com/writing",
    class: "half square",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=28&category=idea-de-proyecto",
  },
  {
    title: "Daily News",
    subtitle: "React Web APP",
    category: "Desarrollo Front-End",
    tags: [
      "React",
      "Redux",
      "Google API",
      "G News API",
      "Axios",
      "Material UI",
    ],
    cover: "./img/projects/daily-news-app-g.webp",
    link: "https://dev.juanfalibene.com/daily-news",
    github_link: "https://github.com/juanfalibene/daily-news",
    class: "half wide",
  },
  {
    title: "Dev Tree",
    subtitle: "Tema de WP",
    category: "Desarrollo Wordpress",
    tags: [
      "PHP",
      "CMS",
      "ACF",
      "CPT UI",
      "Templates",
      "CSS3",
      "HTML5",
      "JS Vanilla",
      "Antigravity",
      "AI",
      "GitHub Actions",
      "Python",
    ],
    cover: "./img/projects/project-wp-theme-dev.webp",
    link: "https://links.juanfalibene.com/dev-tree/",
    class: "half square",
    github_link: "https://github.com/juanfalibene/web-dev-tree",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=235&category=idea-de-proyecto",
  },
  {
    title: "Music Portfolio",
    subtitle: "Navegación",
    category: "Desarrollo Front-End",
    tags: ["React", "React Router", "React Hooks"],
    cover: "./img/projects/project02.webp",
    link: "https://music.juanfalibene.com/",
    github_link: "https://github.com/juanfalibene/react-music-portfolio",
    class: "half square",
  },
  {
    title: "Proyectos Simples",
    subtitle: "Colección",
    category: "Desarrollo Front-End",
    tags: ["JS Vanilla", "React", "CSS3", "HTML5"],
    cover: "./img/projects/song_of_the_day_app.webp",
    link: "https://juanfalibene.com/writing/#/challenges",
    github_link: "https://github.com/juanfalibene/",
    class: "half square",
  },
];

// Clients
export const clients_es = [
  {
    name: "Pablo Martinez Herrera",
    link: "https://www.linkedin.com/in/pablo-mart%C3%ADnez-herrera-93529345/",
    since: 2019,
  },
  {
    name: "Socialisssima",
    link: "https://socialisssima.com",
    since: 2020,
  },
  {
    name: "PS Works",
    link: "https://psworks.es",
    since: 2022,
  },
  {
    name: "Partida Continua",
    link: "https://partidacontinua.com/",
    since: 2023,
  },
];

export const hard_skills_es = [
  {
    skill: "HTML5",
    image: "./img/skills/html-5.svg",
  },
  {
    skill: "CCS3",
    image: "./img/skills/css-3.svg",
  },
  {
    skill: "JS",
    image: "./img/skills/js.svg",
  },
  {
    skill: "React",
    image: "./img/skills/react.svg",
  },
  {
    skill: "Wordpress",
    image: "./img/skills/wordpress.svg",
  },
  {
    skill: "PHP",
    image: "./img/skills/php_02.svg",
  },
  {
    skill: "Python",
    image: "./img/skills/python.svg",
  },
  {
    skill: "Github",
    image: "./img/skills/github-mark-white.svg",
  },
];

export const soft_skills_es = [
  {
    skill: "Resolución de Problemas",
  },
  {
    skill: "Creatividad",
  },
  {
    skill: "Comunicación Efectiva",
  },
  {
    skill: "Orientación al Detalle",
  },
  {
    skill: "Trabajo en Equipo",
  },
  {
    skill: "Gestión del Tiempo",
  },
];

// About
export const about_es = [
  {
    name: "Juan Falibene",
    text: "Barcelona",
    profession: "Desarrollador Web • WordPress & Front-End",
    image: "./img/juanfalibene_profile_hover.jpg",
    imagePic: "./img/juanfalibene_profilepic_06_2025.webp",
    resume_page: "./resume/index.html",
    bio_lead:
      "Desarrollo web integral. Criterio técnico, arquitectura limpia y resultados en los que puedes confiar.",
    bio_story:
      "Llegué al desarrollo de forma híbrida, combinando aprendizaje autodidacta con el trabajo codo a codo con clientes particulares y agencias. Si te interesa saber más, cuento mi recorrido en mi <a href='https://juanfalibene.com/writing/#/post/id=522&category=historia' target='_blank' rel='noopener noreferrer'>historia en el blog</a>.",
    bio_excerpt:
      "Después de más de 6 años colaborando con estudios de diseño, agencias y clientes directos, me adapto a lo que cada proyecto necesita: desarrollo a medida, soporte técnico de marca blanca o consultoría. Me importa que el diseño quede bien y que el código esté limpio, para que cada plataforma sea rápida, segura y fácil de hacer crecer.",
    bio_values:
      "Criterio técnico, no parches. Cada proyecto tiene sus propias limitaciones y su propio stack. No impongo una tecnología concreta; me centro en entender lo que ya hay, construir soluciones sólidas, mejorar el rendimiento y asegurar que la plataforma pueda crecer de forma estable.",
    bio: "Mi <a href='https://juanfalibene.com/writing/#/post/id=522&category=historia' target='_blank' rel='noopener noreferrer'>trayectoria</a> combina educación formal y experiencia autodidacta, creciendo junto a agencias y clientes individuales. Disfruto colaborando en cada fase de un proyecto, buscando siempre el equilibrio entre creatividad, rendimiento y lo que el cliente realmente necesita.",
  },
];

// Sections
export const section_description_es = [
  {
    section: "Trabajos",
    description:
      "En los últimos 6 años me he dedicado a diseñar y desarrollar sitios WordPress para agencias y clientes particulares. Me encargo de todo el proceso: diseño, desarrollo, soporte y transferencia de conocimientos para que cada equipo pueda seguir avanzando por su cuenta.",
  },
  {
    section: "Blog",
    description:
      "En mi <a href='https://juanfalibene.com/writing/' target='_blank' rel='noopener noreferrer'>blog</a> escribo sobre lo que estoy trabajando, desgloso proyectos y reflexiono sobre temas de desarrollo web. También es donde guardo un archivo de todo lo que he construido.",
  },
  {
    section: "Proyectos",
    description:
      "Aplicaciones web a medida, herramientas especializadas y productos digitales interactivos que he desarrollado con arquitecturas modernas, poniendo el foco en rendimiento y código limpio.",
  },
];

// Hero Content (ES)
export const hero_content_es = {
  headline: "Desarrollador Web especializado en WordPress y Front-End. Desarrollo a medida, consultoría y partner tecnológico para agencias y marcas.",
  subtitle: "Ayudo a agencias de diseño, equipos de producto y empresas a crear plataformas web, resolver retos técnicos complejos y hacer crecer sus proyectos con bases sólidas de ingeniería (HTML, CSS, JS/React, PHP).",
  manifesto: "Criterio técnico, no parches. Cada proyecto tiene sus propias limitaciones y su propio stack. No impongo una tecnología concreta; me centro en entender lo que ya hay, sea un maquetador, un tema a medida o un entorno con bloques, para construir soluciones sólidas, mejorar el rendimiento y asegurar que la plataforma pueda crecer.",
};

// Services — Intro Headline & Subtitle (ES)
export const services_intro_es = {
  headline: "Servicios técnicos para agencias y marcas que necesitan desarrollo a medida, criterio técnico y plataformas web que funcionen de verdad.",
  subtitle: "Desarrollo full-stack a medida, colaboración técnica con agencias, auditorías, consultoría y mantenimiento proactivo.",
};

// Services List (ES)
export const services_list_es = [
  {
    id: 1,
    title: "Desarrollo Web & WordPress a Medida",
    description: "Desarrollo frontend y WordPress a medida con arquitecturas modernas, maquetación limpia (HTML5/CSS3/JS/React), temas y plugins personalizados, integración de APIs y bloques nativos (FSE/Gutenberg). Código modular, mantenible y pensado para SEO técnico y tiempos de carga rápidos.",
  },
  {
    id: 2,
    title: "Auditoría Técnica de WordPress",
    description: "Diagnóstico a fondo de rendimiento, salud de la base de datos, arquitectura de plugins/tema y vulnerabilidades de seguridad. Incluye un informe claro con plan de acción priorizado.",
  },
  {
    id: 3,
    title: "Consultoría Técnica y Arquitectura",
    description: "Asesoramiento estratégico antes de un desarrollo o migración. Elegir el stack ideal (maquetador vs. bloques vs. a medida), planificar la arquitectura de datos y definir integraciones con APIs o CRMs.",
  },
  {
    id: 4,
    title: "Mantenimiento Proactivo y Soporte",
    description: "Gestión técnica continuada probando actualizaciones en entornos de prueba (Staging), con backups, monitorización y protocolos de recuperación para evitar caídas en producción.",
  },
  {
    id: 5,
    title: "WPO y Optimización de Rendimiento",
    description: "Optimización real de la velocidad y Core Web Vitals (LCP, CLS, INP) atacando la causa raíz: limpieza de código, optimización de consultas a base de datos y configuración de caché.",
  },
  {
    id: 6,
    title: "Resolución de Problemas y Diagnóstico",
    description: "Intervención técnica para aislar y resolver errores críticos, conflictos de plugins, fallos tras actualizaciones o problemas de seguridad y malware.",
  },
  {
    id: 7,
    title: "Acompañamiento en Lanzamientos",
    description: "Despliegue controlado para el paso a producción: checklist pre-lanzamiento, mapeo de redirecciones SEO (301), pruebas de carga y monitorización post-despliegue.",
  },
];

// Client Fit (ES)
export const client_fit_es = {
  bestFit: [
    "Agencias de diseño y comunicación que buscan un partner técnico senior en quien confiar el desarrollo, soporte o resolución de problemas de sus clientes.",
    "Empresas o marcas con webs activas (maquetadores, temas a medida o bloques) que se encuentran con problemas de rendimiento, caídas, errores tras actualizaciones o limitaciones técnicas.",
    "Equipos que necesitan integrar su web con APIs externas, CRMs o funcionalidades a medida en PHP/JS.",
    "Proyectos que requieren una mirada estratégica antes de rediseñar o migrar, eligiendo la mejor solución según las necesidades del negocio.",
  ],
  notFit: [
    "Quienes buscan soluciones rápidas a base de parches sin querer investigar la causa real del problema.",
    "Colaboraciones donde no se valore el criterio técnico ni haya apertura para mejorar el proyecto juntos. La escala nunca es un filtro: me involucro con la misma dedicación en proyectos pequeños o grandes que tengan sentido y me motiven, siempre que prioricemos una comunicación clara, honesta y directa.",
  ],
};

// FAQs (ES)
export const faqs_es = [
  {
    question: "¿Cómo integras la Inteligencia Artificial y qué valor aporta el criterio técnico frente a la IA?",
    answer: "La IA ya es parte de mi día a día. Esta misma web y muchos de mis proyectos usan herramientas y código asistido por IA. Pero generar código rápido no significa automáticamente tener una plataforma segura, optimizada y escalable. La IA acelera y abre posibilidades creativas, pero el criterio de ingeniería, el diagnóstico profundo, la arquitectura sólida y la responsabilidad sobre lo que se sube a producción siguen siendo lo que evita deuda técnica y garantiza resultados fiables.",
  },
  {
    question: "¿Cómo evitas que la acumulación de parches y plugins genere deuda técnica o caídas tras actualizaciones?",
    answer: "Acumular parches y plugins innecesarios es la causa principal de que una web vaya lenta o se rompa. Mi enfoque: buscar la raíz del problema, sustituir lo que sobra por código nativo y limpio, y probar cualquier actualización en Staging con copias de seguridad activas.",
  },
  {
    question: "¿Cómo te integras con agencias de diseño y equipos de trabajo?",
    answer: "Trabajo como partner técnico o marca blanca. Me integro en tu flujo habitual (Slack, Figma, GitHub, Notion) respetando entregas, estándares de código y la visión de diseño.",
  },
  {
    question: "¿Trabajas únicamente con desarrollo a medida o también con maquetadores como Elementor o WPBakery?",
    answer: "Trabajo sobre el entorno que necesite el proyecto. Si tienes un sitio en producción montado con un maquetador, puedo auditarlo, optimizarlo y corregir fallos sin rehacerlo desde cero. Si el proyecto nace de cero, evaluamos juntos la mejor opción.",
  },
  {
    question: "¿Cómo iniciamos la colaboración?",
    answer: "Puedes solicitar una reunión o escribir un mensaje a través del formulario. En una breve llamada analizamos las necesidades de tu sitio o proyecto y determinamos la mejor vía de trabajo.",
  },
  {
    question: "¿Qué diferencia tu mantenimiento técnico del que ofrecen otros proveedores?",
    answer: "No me limito a hacer clic en 'actualizar' en la web pública. Pruebo las actualizaciones en un entorno clonado (Staging) antes de aplicarlas en producción, con backups activos y monitorización constante para que nada se rompa.",
  },
  {
    question: "¿Qué incluye una Auditoría Técnica?",
    answer: "Recibirás un documento claro con el diagnóstico del estado de tu web: velocidad real, carga en base de datos, riesgo de plugins/tema y seguridad, junto con una lista de acciones ordenadas por prioridad e impacto.",
  },
  {
    question: "¿El código y la web siguen siendo de mi propiedad?",
    answer: "Totalmente. Todo el código, repositorio, accesos e información pertenecen al cliente o agencia. Se entrega con documentación para que el equipo tenga total independencia.",
  },
];

// Blog Links
export const blog_links_es = [
  {
    title: "Rediseño integral y desarrollo a medida para portfolio fotográfico",
    link: "https://juanfalibene.com/writing/#/post/id=2001&category=trabajo-cotidiano",
  },
  {
    title: "Mantenimiento WordPress: el trabajo invisible detrás de una web",
    link: "https://juanfalibene.com/writing/#/post/id=1950&category=trabajo-cotidiano",
  },
  {
    title:
      "Discava! 2.0 - Una APP de Búsqueda de Vinilos con Integración de API",
    link: "https://juanfalibene.com/writing/#/post/id=1943&category=idea-de-proyecto",
  },
  {
    title: "Desarrollando un Bot de Wordpress para Creación de Contenido",
    link: "https://juanfalibene.com/writing/#/post/id=1923&category=idea-de-proyecto",
  },
  {
    title: "Actualizar un proyecto personal con Antigravity",
    link: "https://juanfalibene.com/writing/#/post/id=1890&category=nota",
  },
  {
    title: "Test de Vibe Coding con Lovable App: Calitrack",
    link: "https://juanfalibene.com/writing/#/post/id=1909&category=idea-de-proyecto",
  },
  {
    title: "CV Web 2025",
    link: "https://juanfalibene.com/writing/#/post/id=1824&category=historia",
  },
  {
    title: "Wireframes: de la idea al diseño implementado",
    link: "https://juanfalibene.com/writing/#/post/id=1369&category=trabajo-cotidiano",
  },
  /*{
    title: "Autocompletado con IA de Windsurf",
    link: "https://juanfalibene.com/writing/#/post/id=837&category=nota",
  },*/
  {
    title: "Explorando Python y Automatización",
    link: "https://juanfalibene.com/writing/#/post/id=776&category=reflexion",
  },
  {
    title: "Probando GPT o3-mini-high",
    link: "https://juanfalibene.com/writing/#/post/id=756&category=nota",
  },
  {
    title: "Día a día: Proyecto con ChatGPT",
    link: "https://juanfalibene.com/writing/#/post/id=752&category=idea-de-proyecto",
  },
  {
    title: "Introducción a WP Headless",
    link: "https://juanfalibene.com/writing/#/post/id=28&category=idea-de-proyecto",
  },
];

// About Links
export const about_links_es = [
  {
    name: "Linkedin",
    link: "https://www.linkedin.com/in/juanfalibene/",
    category: "professional",
  },
  {
    name: "GitHub",
    link: "https://github.com/juanfalibene",
    category: "professional",
  },
  {
    name: "Blog",
    link: "https://juanfalibene.com/writing/",
    category: "personal",
  },
  {
    name: "Música",
    link: "https://music.juanfalibene.com",
    category: "personal",
  },
  {
    name: "Dev & UX/UI Resources",
    link: "https://links.juanfalibene.com/dev-tree",
    category: "development",
  },
  {
    name: "Discava! (Discogs API)",
    link: "http://dev.juanfalibene.com/discava/index.html",
    category: "development",
  },
  {
    name: "©Juan Falibene 2026",
    category: "credit",
  },
  {
    name: "Barcelona",
    category: "credit",
  },
];

// Certificates
export const certificates_es = [
  {
    name: "Desenvolupament web Front End CIFO L'Hospitalet",
    link: "https://juanfalibene.com/resume/downloads/Certificat-417219-Y8901768T.PDF",
    year: 2023,
  },
  {
    name: "SEO, SEM i analítica Web",
    link: "https://juanfalibene.com/resume/downloads/16_ca355c68-8cdf-4f34-b3a4-8c8c0aadb87b_f2150287-6a9e-44e7-afd7-3ecc90493f73.pdf",
    year: 2025,
  },
  {
    name: "Backend & Automation: Python, Flask, Django",
    link: "https://juanfalibene.com/resume/downloads/diploma.pdf",
    year: 2025,
  },
  {
    name: "English Reading(C2) & Listening(B2) EF SET",
    link: "https://juanfalibene.com/resume/downloads/EF_SET_Certificate.pdf",
    year: 2024,
  },
  {
    name: "CSS: Diseño web responsive",
    link: "https://juanfalibene.com/resume/downloads/1673896108444.png",
    year: 2023,
  },
  {
    name: "Diseño de interfaz (UI)",
    link: "https://juanfalibene.com/resume/downloads/1673478097062.png",
    year: 2023,
  },
  {
    name: "Experiencia de usuario (UX)",
    link: "https://juanfalibene.com/resume/downloads/1673444494312.png",
    year: 2023,
  },
];

// Resume
export const resume_urls_es = [
  {
    name: "Currículum ESP PDF",
    link: "https://juanfalibene.com/resume/downloads/Juan_Ignacio_Falibene_CV_2026.pdf",
    action: "Descargar",
  },
  {
    name: "Currículum ENG PDF",
    link: "https://juanfalibene.com/resume/downloads/Juan_Ignacio_Falibene_CV_EN_2026.pdf",
    action: "Descargar",
  },
  {
    name: "Currículum Online",
    link: "https://juanfalibene.com/resume/index.html",
    action: "Ver",
  },
];
